import React from 'react'

// value: can be a fraction (0..1) or an absolute number within [min,max]
// min/max: numbers displayed under the chart (defaults 0..100)
// precision: decimals for value label
const ExposureBar = ({ value = 0.5, min = 0, max = 100, precision = 0 }) => {
  const isFraction = value >= 0 && value <= 1
  const denom = Math.max(0.000001, max - min)
  const current = isFraction ? value * 100 : ((value - min) / denom) * 100
  const percentage = Math.max(0, Math.min(100, current))
  const displayValue = isFraction ? (value * 100).toFixed(precision) : Number(value).toFixed(precision)
console.log("dfsfsd",value,max,isFraction)

  return (
    <div className="mt-2">
      <div className="relative w-full rounded-full bg-gradient-to-r from-emerald-500 via-yellow-400 to-red-500 p-[2px]">
        <div className="h-4 w-full rounded-full bg-black/30 relative">
          <div
            className="h-4 rounded-full bg-white/90"
            style={{ width: `${percentage}%` }}
          />
          {/* Value badge */}
          <div
            className="pointer-events-none absolute -top-[23px] translate-x-[-50%] whitespace-nowrap rounded-md dark:bg-white bg-customHeader/20 px-2 py-0.5 text-[11px] font-medium text-customBlack shadow"
            style={{ left: `${percentage}%` }}
          >
            {isFraction ? `${displayValue}%` : `${Number(displayValue).toLocaleString()} (${percentage.toFixed(0)}%)`}
          </div>
        </div>
      </div>
      {/* Range labels */}
      <div className="mt-1 flex items-center justify-between text-xs dark:text-white/70 text-customBlack/70">
        <span>{isFraction ? 0 : Number(min).toLocaleString()}</span>
        <span>{isFraction ? max : Number(max).toLocaleString()}</span>
      </div>
    </div>
  )
}

export default ExposureBar
